import { call, put, takeEvery } from 'redux-saga/effects';
import { getCapBrands } from '../../../requests/cap_requests/get_cap_brands_request';
import { getLeadsCapBrandsRequestSuccess, getLeadsCapBrandsRequestFailure } from '../../actions/cap_actions/get_cap_brands.actions';
import { GET_LEADS_CAP_BRANDS_REQUEST } from '../../constants/cap.constants';
import { message_error } from '../../../../../../components/Message';

function* getCapBrandsRequest() {
    const { result, options, error } = yield call(getCapBrands);
    if (result) {
        yield put(getLeadsCapBrandsRequestSuccess(options));
    } else {
        yield put(getLeadsCapBrandsRequestFailure(error));
        message_error(error);
    }
}

export default function* getCapBrandsSaga() {
    yield takeEvery(GET_LEADS_CAP_BRANDS_REQUEST, getCapBrandsRequest);
}



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/sagas/cap.sagas/get_cap_brands.saga.js